<template>
  <div class="header">
    <div class="header-left">
      <div class="title-box"></div>
      <div class="date">
        <span>有效期至：{{userInfo.pwdInactiveDate}}</span>
<!--        <el-popover
          placement="bottom-start"
          width="400"
          trigger="hover">
          <h4 style="display: flex;align-items: center">
            <img style="margin-right: 10px" src="/static/h-service.png" class="img-logo"/>
            <span>服务商：西安店播云信息科技有限公司</span>
          </h4>
          <h4 style="display: flex;align-items: center;margin: 6px 0;">
            <img style="margin-right: 10px" src="/static/h-phone.png" class="img-logo"/>
            <span>联系电话：4006-727-801</span>
          </h4>
          <h4 style="display: flex;align-items: center">
            <img style="margin-right: 10px" src="/static/h-address.png" class="img-logo"/>
            <span>公司地址：陕西省西安市莲湖区新世纪大厦1111室</span>
          </h4>
          <el-button slot="reference" type="text">续费</el-button>
        </el-popover>-->
      </div>
      <div class="analysis">
        <div class="loader-inner line-scale-pulse-out-rapid success">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="analysis-title" @click="analysisClick">智能分析</div>
      </div>
<!--      <i class="el-icon-s-data" style="margin-left: 100px"></i><span class="analysis-title" @click="analysisClick">智能分析</span>-->
    </div>
    <div class="user-info">
      <div class="user cursor">
        <el-popover
          placement="bottom-start"
          width="250"
          trigger="hover">
          <div>
            <h4>{{userInfo.merchantName}}</h4>
            <h4>ID：{{userInfo.merchantNo}}</h4>
            <h4>用户名：{{userInfo.name}}</h4>
            <h4>有效期至：{{userInfo.pwdInactiveDate}}</h4>
          </div>
          <img slot="reference" src="/static/default-icon.png"/>
        </el-popover>
        <span v-if="userInfo" style="font-size: 14px">{{ userInfo.name }}</span>
<!--        <el-dropdown @command="changeUser" trigger="click">-->
<!--          <span class="el-dropdown-link" v-if="userInfo">-->
<!--            {{ userInfo.name }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </span>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item :command="item" v-for="(item,index) of userList" :key="index">{{item.username}}</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
      </div>
      <el-dropdown>
        <span class="user cursor" style="font-size: 14px">
          软件下载<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="width:300px">
          <el-dropdown-item style="display: flex;align-items: center;padding:5px 10px;justify-content: space-between" v-for="(item,index) of softList" :disabled="item.disabled" :key="index">
            <div style="display: flex;align-items: center">
              <img :src="item.src"/>
              <span style="padding-left:5px">{{item.name}}</span>
            </div>
            <el-tag size="medium":type="item.tagType"  @click="download(item)">下载</el-tag>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div style="line-height: 35px;font-size: 14px;margin-right: 20px;">
        <el-link style="color:#fff;font-size: 14px" href="https://support.qq.com/product/351333" target="_blank">帮助</el-link>
      </div>
      <div class="log-out" @click="logOut">安全退出</div>
    </div>
    <el-dialog title="小程序二维码" :visible.sync="showQrcode">
      <div style=";text-align: center">
        <img src="/static/appletLogo.jpg" alt="" style="width: 50%">
      </div>
    </el-dialog>
    <el-dialog title="智能经营分析" :visible.sync="showBox" class="analysis-dialog" :before-close="closeAnalysis" :close-on-click-modal="false">
      <Analysis v-if="showAnalysis" @close="closeTemplate"></Analysis>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/config/api";
import Loading from '@/components/template/loading'
import Analysis from "@/components/business/analysis";
export default {
  components:{Analysis, Loading  },
  data() {
    return {
      showAnalysis:false,
      showBox:false,
      showQrcode:false,
      softList:[
        {name: '安卓收银', src: '/static/imageAndroid.png', tagType: '', disabled: false, type: 10},
        {name: 'Windows收银', src: '/static/imageWindows.png', tagType: '', disabled: false, type: 20},
        {name: '自助收银', src: '/static/imageSelfHelp.png', tagType: '', disabled: false, type: 30},
        {name: '店小二', src: '/static/imageApplets.png', tagType: '', disabled: false, type: 40},
        {name: '移动销售', src: '/static/imagePhone.png', tagType: '', disabled: false, type: 50},
        // {name: '安卓收银', src: '/static/安卓.png', tagType: '', disabled: false, type: 10},
        // {name: 'Windows收银', src: '/static/windows.png', tagType: '', disabled: false, type: 20},
        // {name: '自助收银', src: '/static/自助.png', tagType: '', disabled: false, type: 30},
        // {name: '店小二', src: '/static/小程序.png', tagType: '', disabled: false, type: 40},
        // {name: '移动销售', src: '/static/手机.png', tagType: '', disabled: false, type: 50},
      ],
      loading:false,
      userInfo: {},
      noticeList: [],
      currentTime: '',
      scrollWidth: 0,
      moveArea: null,
      itemBoxWidth: 0,
      time: null,
      userList:[
        {username:'cs_010101',password:'123456',merchantNo:'88223123'},
        {username: 'cs_0001',password:'123456',merchantNo:'88223123'}
      ],
    }
  },
  created() {
    let date = new Date();
    this.currentTime = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
    this.userInfo = this.$utils.getSysUser();
    this.isHasInviteCode = this.userInfo.inviteCode?false:true//显示续费
  },
  mounted() {

  },
  methods: {
    // 关闭智能分析 刷新数据
    closeAnalysis(){
      this.showBox = false
      this.showAnalysis = false
    },
    // 点击详情页 关闭窗口 缓存数据
    closeTemplate(){
      this.showBox = false
    },
    // 点击智能分析
    analysisClick(){
      this.showBox = true
      this.showAnalysis = true
    },
    // 切换用户
    changeUser(val){
      this.$confirm('切换到用户'+val.username+'？确认')
        .then(_ => {
          localStorage.clear();
          this.changeLogin(val.username,val.password,val.merchantNo,).then(()=>{
            // this.$emit('refresh')
          })
        })
        .catch(_ => {});
    },
    // 切换登录
    changeLogin(username,password,merchantNo){
      return new Promise((resolve, reject) => {
        let params = {
          username:username,
          password:this.$utils.md5(password),
          merchantNo:merchantNo
        }
        const loading = this.$loading({lock: true});
        this.$axios
          .fetchPost(api.login, qs.stringify(params), {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            loginType: 10,
          })
          .then((data) => {
            loading.close()
            if (data.code == 200) {
              if (this.rememberUser) {
                this.$utils.setUserName(this.form.username);
              } else {
                this.$utils.clearUserName();
              }
              this.$utils.setSysUser(data.data.user || {});
              this.$utils.setUserMenu(data.data.menu || {});
              this.$utils.setSessionID(data.data.key);
              this.$router.push({ path: "/index" });
              this.getCacheData();
              resolve()
            } else {
              this.$message({ message: data.message+data.code, type: "error" });
            }
          })
          .catch((err) => {
            console.log(err)
            loading.close()
          });
      });
    },
    getCacheData() {
      this.$axios.fetchGet(api.getStatus).then((data) => {
        this.$utils.setCache(data.data || {});
      });
    },
    // 退出登录
    logOut() {
      this.$confirm('退出系统？确认')
        .then(_ => {
          this.$axios
            .fetchPost('/api/logout', {}, {loginType: 10})
            .then(data => {
              if (data.code == 200) {
                let userName = this.$utils.getUserName();
                localStorage.clear();
                if (userName)
                  this.$utils.setUserName(userName);
                this.$router.push({path: '/login'});
              } else {
                this.$message({message: data.msg, type: "error"});
              }
            });
        })
        .catch(_ => {});

    },
    // 点击下载软件
    download(item) {
      if(item.type === 10){//安卓收银
        this.getSoft(10)
      }else if(item.type === 20){//Windows收银
        this.getSoft(20)
      }else if(item.type === 30){//自助收银
        window.location.href='https://jarvis-1302225989.cos.ap-chongqing.myqcloud.com/data/tomcat/tomcat-jarvis-6060/temp/1627640909013/online_v1.0_1.apk'
      }else if (item.type === 40) {//店小二
        this.showQrcode = true
      } else if (item.type === 50) {
        this.getSoft(30)
      }
    },
    // 软件接口
    getSoft(val){
      this.$axios.fetchPost('/api/system/sysSoftwareVersion/download?type='+val, {}).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
          } else {
            this.$message({message: data.errorMsg, type: "error"});
          }
        });
    },
  }
}
</script>
<style>
.header {
  background-color: #20222a;
  width: 100%;
  height: 60px;
  color: #fcfcfc;
  font-size: 16px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header .header-left{
  display: flex;
  align-items: center;
}
.header .activity {
  width: 35%;
  overflow: hidden;
  height: 50px;
  line-height: 50px;
  position: relative;
}

.header .item-box {
  white-space: nowrap;
  height: 50px;
  position: absolute;
}

.header .activity .activity-item {
  margin-right: 10px;
  display: inline;
}

.header .title-box {
  background-image: url(../../assets/images/logo.png);
  background-size: 100% 100%;
  margin-top: 3px;
  position: relative;
  width: 160px;
  height: 34px;
  padding-left: 15px;
}

/* .header .title-box .title::before{
    content: '';
    position: absolute;
    left: 0;
    top: 2.2px;
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/logo.png);
    background-size: 100% 100%;
} */
.header .header-menu {
  margin-left: 50px;
}

.header .header-menu .el-dropdown {
  color: #f0f0f0;
  font-size: 14px;
  margin-right: 30px;
}
.header .user-info{
  display: flex;
  align-items: center;
}
.header .user-info .user {
  line-height: 40px;
  color:#fff;
  margin-right: 20px;
}

.header .date {
  font-size: 14px;
  line-height: 40px;
  margin-left: 100px;
}
.header .date .itemLine{
  line-height: 40px;
}
.header .sun-icon {
  margin-top: 10px;
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  display: inline-block;
}

.header .log-out {
  line-height: 40px;
  font-size: 14px;
  cursor: pointer;
}

.header .user-info img {
  vertical-align: middle;
  width: 26px;
  height: 26px;
  margin-right: 4px;
}
.header .el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.header .el-icon-arrow-down {
  font-size: 12px;
}
.header .el-dropdown-link{
  color:#fff;
}
.header >>> el-dropdown .menu-item-style {
  display: flex;
  align-items: center;
}
.header h4{
  display: flex;
  align-items: center;
}
.img-logo{
  width: 20px;
  height:20px;
}
.el-icon-s-data{
  font-size: 20px;
  background-image: -webkit-linear-gradient(top, rgb(201, 115, 255), rgb(20, 11, 255));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.analysis-title{
  font-size: 14px;
  cursor: pointer;
  padding-left:10px;
}
.analysis-dialog .el-dialog{
  border-radius: 8px;
  min-width: auto;
  margin-top:12vh !important;
  max-height:unset;
  height:70vh !important;
}
.analysis-dialog .el-dialog__header{
  border-radius: 8px;
}
.analysis-table tr{
  height:30px;
  line-height: 30px;
}
/*动态分析图标*/
.line-scale-pulse-out-rapid.success > div {
  background-image: -webkit-linear-gradient(top, rgb(201, 115, 255), rgb(20, 11, 255));
}
.line-scale-pulse-out-rapid>div{
  width:3px;
  height:20px;
  margin-right: 0;
  display:inline-block;
  /*border-radius:2px;*/
  /*margin-right:2px;*/
  vertical-align:middle;
  -webkit-animation:line-scale-pulse-out-rapid .9s -.5s infinite cubic-bezier(.11,.49,.38,.78);
  animation:line-scale-pulse-out-rapid .9s -.5s infinite cubic-bezier(.11,.49,.38,.78)
}
.line-scale-pulse-out-rapid>div:nth-child(2),.line-scale-pulse-out-rapid>div:nth-child(4){
  -webkit-animation-delay:-.25s!important;
  animation-delay:-.25s!important
}
.line-scale-pulse-out-rapid>div:nth-child(1),.line-scale-pulse-out-rapid>div:nth-child(5){
  -webkit-animation-delay:0s!important;
  animation-delay:0s!important
}
@-webkit-keyframes line-scale-pulse-out-rapid{
  0%,90%{
    -webkit-transform:scaley(1);
    transform:scaley(1)
  }
  80%{
    -webkit-transform:scaley(.3);
    transform:scaley(.3)
  }
}
@keyframes line-scale-pulse-out-rapid{
  0%,90%{
    -webkit-transform:scaley(1);
    transform:scaley(1)
  }
  80%{-webkit-transform:scaley(.3);
    transform:scaley(.3)
  }
}
.analysis{
  margin-left: 100px;
  display: flex;
}
@media screen and (max-width: 1200px) {
  .header .date{
    margin-left: 50px;
  }
  .analysis{
    margin-left: 50px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/business/header.vue